var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#FEF0ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6676 15.1575L24.6676 13.6575C24.4608 13.5526 24.2319 13.4986 24.0001 13.5H23.9101C23.72 13.5061 23.5354 13.5656 23.3776 13.6717C23.2197 13.7779 23.0949 13.9263 23.0176 14.1C22.8317 14.4764 22.5443 14.7933 22.1878 15.0149C21.8312 15.2365 21.4198 15.3539 21.0001 15.3539C20.5803 15.3539 20.1689 15.2365 19.8123 15.0149C19.4558 14.7933 19.1684 14.4764 18.9826 14.1C18.9052 13.9263 18.7804 13.7779 18.6226 13.6717C18.4647 13.5656 18.2802 13.5061 18.0901 13.5H18.0001C17.7658 13.4991 17.5347 13.5531 17.3251 13.6575L14.3251 15.1575C14.0027 15.3193 13.7495 15.5919 13.6117 15.9252C13.474 16.2586 13.461 16.6304 13.5751 16.9725L14.3251 19.2225C14.4443 19.5826 14.6955 19.8841 15.028 20.0664C15.3606 20.2487 15.7499 20.2982 16.1176 20.205L17.2501 19.92V24.75C17.2501 24.9489 17.3291 25.1397 17.4697 25.2804C17.6104 25.421 17.8011 25.5 18.0001 25.5C18.3979 25.5 18.7794 25.6581 19.0607 25.9394C19.342 26.2207 19.5001 26.6022 19.5001 27V27.75C19.5001 27.9489 19.5791 28.1397 19.7197 28.2804C19.8604 28.421 20.0511 28.5 20.2501 28.5H21.7501C21.949 28.5 22.1397 28.421 22.2804 28.2804C22.421 28.1397 22.5001 27.9489 22.5001 27.75V27C22.5001 26.6022 22.6581 26.2207 22.9394 25.9394C23.2207 25.6581 23.6022 25.5 24.0001 25.5C24.199 25.5 24.3897 25.421 24.5304 25.2804C24.671 25.1397 24.7501 24.9489 24.7501 24.75V19.92L25.8826 20.205C26.2502 20.2982 26.6395 20.2487 26.9721 20.0664C27.3047 19.8841 27.5558 19.5826 27.6751 19.2225L28.4251 16.9725C28.5386 16.6295 28.5244 16.257 28.3853 15.9236C28.2461 15.5901 27.9913 15.3181 27.6676 15.1575Z",
    fill: "#BC030E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextile);
export default __webpack_public_path__ + "static/media/textile.a5459e8869b95275a0072be7c0d152fa.svg";
export { ForwardRef as ReactComponent };